import { useCallback, useState } from 'react'
import { AccountAssumption } from 'admin/utils/AccountAssumption'

export const useAccountAssumption = ({ isAdmin }) => {
  const [assumedUser, setAssumedUser] = useState(null)

  const assumeUserAccount = useCallback(
    async (userId) => {
      if (!isAdmin) return false
      await AccountAssumption.assumeInto(userId)
      setAssumedUser(userId)
    },
    [isAdmin, setAssumedUser]
  )

  const unassume = useCallback(async () => {
    await AccountAssumption.unassume()
    setAssumedUser(null)
  }, [setAssumedUser])

  return {
    assumedUser,
    setAssumedUser,
    assumeUserAccount,
    unassume,
  }
}
